import { ResourceDefinition, ResourceSections } from 'src/types';
import { Campaign } from '@mui/icons-material';
import { GET_LIST, GET_MANY, GET_ONE, UPDATE } from 'react-admin';
import PortalProgramsList from './List';
import { PortalProgramsEdit } from './Edit';
import { PortalProgramsCreate } from './Create';

export const ProgramsResource: ResourceDefinition = {
  name: 'programs',
  section: ResourceSections.PORTAL,
  icon: Campaign,
  options: { label: 'Programs' },

  list: PortalProgramsList,
  edit: PortalProgramsEdit,
  create: PortalProgramsCreate,

  permissions: {
    list: ['programs:read'],
    create: ['programs:edit'],
    edit: ['programs:edit'],
  },

  extension: {
    operations: {
      [GET_LIST]: {
        operationName: 'portal_programs',
      },
      [GET_ONE]: {
        operationName: 'portal_programs',
      },
      [GET_MANY]: {
        operationName: 'portal_programs',
      },
      [UPDATE]: {
        operationName: 'update_programs_by_pk',
      },
    },
  },
};
